import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-ntv',
  templateUrl: './ntv.component.html',
  styleUrls: ['./ntv.component.css']
})
export class NtvComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
  }

}
